import { useState } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { colors, MicrosoftIcon } from "@dotnet/telematics-design-system";

import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button";
import { body2BoldStyles, body4SemiBold } from "shared/styles/typography";
import { REDIRECTIONS } from "shared/types/enums";

const SingleSignOn = () => {
    const { gray300, gray700 } = colors;

    const { t } = useTranslation();

    const [isLoading, setIsLoading] = useState(false);

    const handleClick = () => {
        setIsLoading(true);

        window.location.href = `${import.meta.env.VITE_BASE_URL}${REDIRECTIONS.LoginEntraId}`;
    };

    return (
        <div>
            <div
                css={css({
                    display: "flex",
                    alignItems: "center",
                    margin: "16px 0",

                    "& > span:nth-of-type(1), & > span:nth-of-type(3)": {
                        flex: 1,
                        height: "1px",
                        background: gray300
                    },

                    "& > span:nth-of-type(2)": {
                        ...body2BoldStyles,
                        color: gray300,
                        textTransform: "uppercase",
                        margin: "0 16px"
                    }
                })}
            >
                <span />
                <span>{t("General##or")}</span>
                <span />
            </div>

            <Button
                fullWidth
                color={BUTTON_COLORS.Secondary}
                size={BUTTON_SIZES.Normal}
                variant={BUTTON_VARIANTS.IconLeft}
                icon={<MicrosoftIcon />}
                isLoading={isLoading}
                onClick={handleClick}
            >
                {t("Auth##sso")}
            </Button>

            <p
                css={[
                    body4SemiBold,
                    { color: gray700, textAlign: "right", margin: "8px 0 0" }
                ]}
            >
                *{t("Auth##for ms365")}
            </p>
        </div>
    );
};

export default SingleSignOn;
